// extracted by mini-css-extract-plugin
export default {"div":"Form_div__hqolX","label":"Form_label__X1aSO","input":"Form_input__YGkuc","error":"Form_error__JWyog","formButton":"Form_formButton__n0lQA"};